<template>
    <div class="goods-lable-box" v-if="returnShow">
        <template v-for="(item, index) in textElements">
            <template v-if="shouldRender(item)">
                <template v-if="item.showPop">
                    <el-popover v-model="popoverStates[item.id]" placement="bottom-start"
                        :width="width" :trigger="trigger" :visible-arrow="false" popper-class="goods-label-popover">
                        <div class="content">
                            <p>{{ item.content }}信息：</p>
                            <template v-for="content_item in returnLabel_content(item)">
                                <div>
                                    <p v-if="content_item.title" class="content_item_title">{{ content_item.title }}：</p>
                                    <p class="content_item_value">{{ content_item.content }}</p>
                                </div>
                            </template>
                        </div>
                        <el-tag slot="reference" @click.stop="togglePopover(item)" size="mini" :type="item.type"
                            :class="item.className" :key="index" :style="item.style">{{ item.content }}</el-tag>
                    </el-popover>
                </template>
                <template v-else-if="item.showCopy">
                    <el-popover v-model="popoverStates[item.id]" placement="bottom-start"
                        :width="width" :trigger="trigger" :visible-arrow="false" popper-class="goods-label-popover">
                        <div class="content copy-content">
                            <div @click="copy(item.copyContent)">
                                <span>复制</span>
                            </div>
                            <span class="copy-content-text">{{item.copyContent}}</span>
                        </div>
                        <el-tag slot="reference" @click.stop="togglePopover(item)" size="mini" :type="item.type"
                            :class="item.className" :key="index" :style="item.style">{{ item.content }}</el-tag>
                    </el-popover>
                </template>
                <template v-else>
                    <el-tag size="mini" :type="item.type" :class="item.className" :key="index" :style="item.style">{{item.content }}</el-tag>
                </template>
            </template>
        </template>
        <div @click.stop="closeAll" class="tag_bg" v-if="returnShowBg&&trigger!=='hover'"></div>
    </div>

</template>

<script>
import { mapGetters } from "vuex"
export default {
    props: {
        width: {
            type: String,
            default: '200'
        },
        goods: {
            type: Object,
            default: () => { }
        },
        
        trigger:{
            type: String,
            default: 'hover' // manual 通过点击控制进行打开
        }
    },
    data() {
        return {
            tagOptions: [],
            popoverStates: {
                'country-code': false,
                'getfree': false,
                'seckill': false,
                'discount': false,
                'wholesale': false,
                'out-of-stock': false
            }, // 存储弹窗状态
        }
    },
    computed: {
        ...mapGetters(["token"]),
        textElements() {
            const defaultStyle = 'border:none;display:flex;line-height: 22px;';
            // 生成标签样式
            const getTagStyle = (type) => {
                if (!this.goods.promotion_color) return '';
                const colors = this.goods.promotion_color;
                return `background-color: ${colors[`${type}_background_color`]};color: ${colors[`${type}_font_color`]};${defaultStyle}`;
            };
            if(!this.goods) return [];
            // 标签配置
            const tagConfig = [
                {
                    id: 'getfree',
                    condition: () => !!this.goods.is_getfree || !!this.goods.get_free_goods || !!this.goods.get_goods_free,
                    className: 'getfree',
                    content: '换购',
                    showPop: true,
                    type: 'error'
                },
                {
                    id: 'seckill', 
                    condition: () => this.goods.promotion_label === 'seckill',
                    className: 'promotion',
                    content: '秒杀',
                    type: 'error'
                },
                {
                    id: 'discount',
                    condition: () => this.goods.promotion_label === 'discount', 
                    className: 'promotion',
                    content: '特价',
                    showPop: true,
                    type: 'error'
                },
                {
                    id: 'wholesale',
                    condition: () => this.goods.promotion_label === 'wholesale' || !!this.goods.wholesale_goods_id,
                    className: 'promotion', 
                    content: '阶梯',
                    showPop: true,
                    type: 'error'
                },
                {
                    id: 'bundling',
                    condition: () => this.goods.promotion_label === 'bundling',
                    className: 'promotion',
                    content: '组合套餐',
                    type: 'error'
                }
            ];

            return tagConfig.map(tag => ({
                ...tag,
                style: getTagStyle(tag.id)
            }));
        },
        returnShow() {
            let arr = this.textElements.filter(item => {
                if(this.shouldRender(item)){
                    return item;
                }
            });
            if(arr.length>0){
                return true;
            }else{
                return false;
            }
        },
        returnShowBg() {
            if (!this.popoverStates) {
                return false;
            }
            for (let key in this.popoverStates) {
                if (this.popoverStates[key]) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        togglePopover(info) {
            if (this.trigger === 'hover') {
                return;
            }
            this.popoverStates[info.id] = !this.popoverStates[info.id];
        },
        returnLabel_content(info) {
            switch (info.id) {
                case 'getfree':
                    return this.returnFreeText();
                 case 'wholesale':
                    return this.returnwholesaleText();
                case 'discount':
                    return this.returnDiscountText();
                default:
                    return []
            }
        },
        // 返回阶梯相关信息
        returnwholesaleText(){
             let textArr = [];
            let text_bool = (this.goods.promotion_info?.price_json && this.goods.promotion_info.price_json.length>0) || this.goods.price_json
            if(!text_bool){
                return textArr;
            }
            let priceJon =  this.goods.promotion_info?.price_json || JSON.parse( this.goods.price_json)
            textArr =priceJon.map((item)=>{
              return {title:``,content:`${item.num}${this.goods.unit ? this.goods.unit : '个'}起批，限购数量：${item.limit_num}，价格：¥${item.price}`}
            })
            return textArr;
        },
        // 返回换购相关信息
        returnFreeText() {
            let textArr = [];
            let text_bool = true;
            if(this.goods.get_free_goods||this.goods.get_goods_free){
                text_bool = false;
            }
            if(text_bool){
                return textArr;
            }
            let temObj = this.goods.get_free_goods||this.goods.get_goods_free;
            let bool = (temObj.is_ladder > 0);
            // 当前主商品的单位
            let main_unit = (this.goods.unit ? this.goods.unit : '盒');
            temObj.getFreeGoods.forEach(item => {
                // 是否是本商品
                let ifBenPing = (item.goods_id===this.goods.goods_id);
                // 副商品单位
                let fu_unit = (item.goods.unit?item.goods.unit:'盒');
                if (bool) {
                    if (typeof item.ladder_json === 'string') {
                        item.ladder_json = JSON.parse(item.ladder_json)
                    }
                    item.ladder_json.forEach((item1, index) => {
                        let limit = (item.limit||item.goods_limit||0);
                        let price = (parseFloat(item1.rangPrice)*parseInt(item1.rang)).toFixed(2);
                        let str = `单次购买本商品${item1.mainRang}${main_unit}+${price}元换购${item1.rang}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                        if(limit>0){
                            str += `,限购${item.limit}${fu_unit}`;
                        }
                        let textObj = {title:'',content:str};
                        if(ifBenPing){
                            textArr.unshift(textObj);
                        }else{
                            textArr.push(textObj);
                        }
                    });
                } else {
                    let price = (parseFloat(item.price)*parseInt(item.num)).toFixed(2);
                    let str = `单次购买本商品${item.count}${main_unit}+${price}元换购${item.num}${fu_unit}${ifBenPing?'本品':item.goods.goods_name}`;
                    if (item.limit > 0) {
                        str +=`,限购${item.limit}${fu_unit}`;
                    }
                    let textObj = {title:'',content:str}
                    textArr.push(textObj);
                }
            })
            return textArr;
        },
        // 返回特价相关信息
        returnDiscountText(){
            let textArr = [];
            if(this.goods.promotion_info){
                textArr.push({
                    title:'',
                    content:`购买数量达到${this.goods.promotion_info.goods_min}可享受特价`
                })
                if(this.goods.promotion_info.num_multiple>1){
                    textArr.push({
                        title:'',
                        content:`特价仅${this.goods.promotion_info.num_multiple}的倍数可享受，超出按原价计算`
                    })
                }
                textArr.push({
                    title:'',
                    content:`限购数量：${this.goods.promotion_info.goods_limit>0?this.goods.promotion_info.goods_limit:'无上限'}`
                })
            }
            textArr.push({
                title:'',
                content:`原价：${this.goods.price} 特价：${this.goods.discount_price}`
            })
            return textArr;
        },
        shouldRender(item) {
            return item.condition();
        },
        closeAll() {
            for (let key in this.popoverStates) {
                this.popoverStates[key] = false;
            }
        },
        copy(content){
            this.$util.copy(content);
            this.$message.success('复制成功');
        }
    }
}
</script>
<style>
.goods-label-popover {
    padding: 6px;
    margin-top: 6px !important;
    box-sizing: border-box;
    border: 1px solid #32BC6F;
}
</style>
<style lang="scss" scoped>
.goods-lable-box {
    display: flex;
    align-items: center;
    gap: 6px;
    >span{
        display: flex;
    }
}
.copy-content{
    align-items: center;
    flex-direction: row !important;
    >div:nth-child(1){
        padding: 2px;
        box-sizing: border-box;
        border: 1px solid #32BC6F;
        border-radius: 4px;
        cursor: pointer;
        flex-shrink: 0;
        >span{
            font-size: 12px;
            line-height: 14px;
            color: #32BC6F;
        }
    }
    >.copy-content-text{
        font-size: 12px;
        line-height: 14px;
        color: #333;
    }
}
.content{
    display: flex;
    flex-direction: column;
    gap: 6px;
    >p:nth-child(1){
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    >div:not(:first-child){
        display: flex;
        flex-direction: column;
        gap: 6px;
        >p:nth-child(1){
            font-size: 12px;
            line-height: 14px;
            color: #32BC6F;
        }
        >p:nth-child(2){
            font-size: 12px;
            line-height: 14px;
            color: #787878;
        }
    }
    
}
.tag_bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 9999;
    cursor: default;
}
</style>